import { render } from "./IconAddMoney.vue?vue&type=template&id=2ba290bd"
import script from "./IconAddMoney.vue?vue&type=script&lang=js"
export * from "./IconAddMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconAddMoney.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ba290bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ba290bd', __exports__)) {
    api.reload('2ba290bd', __exports__)
  }
  
  module.hot.accept("./IconAddMoney.vue?vue&type=template&id=2ba290bd", () => {
    api.rerender('2ba290bd', render)
  })

}


export default __exports__